/*
 * Copyright (c) 2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import {useCallback} from "react";
import Dates from "utils/Dates";
import {useTypedSelector} from "helpers/reducers";

export const useOfferFlow = () => {
    const bookingProcess = useTypedSelector((state) => state.bookingState.bookingProcess)
    const bookingFilter = bookingProcess.filter

    const startTimeslotDate = useCallback(() => {
        return bookingProcess.selectedTimeslot ? new Date(bookingProcess.selectedTimeslot?.start_at) : null
    }, [bookingProcess.selectedTimeslot])()

    const dateInvalid = useCallback(() => {
        if (startTimeslotDate && startTimeslotDate) {
            const dateDiff = Dates.daysDifference(startTimeslotDate, bookingFilter.date)
            return dateDiff < 0 || dateDiff > 1
        }
        return true
    }, [bookingFilter.date, startTimeslotDate])

    const isNextDisabled: boolean = !bookingProcess.selectedTimeslot || dateInvalid()

    return {
        isNextDisabled,
    }
}
